import {
  Type,
  Injectable,
  OnDestroy,
  ViewContainerRef,
  ComponentRef,
  ComponentFactoryResolver,
  EventEmitter,
} from '@angular/core';
import * as _ from 'lodash';


@Injectable()
export class DynamicComponentLoader {

  components: any = {};
  componentRef: ComponentRef<any>;

  constructor(private _componentFactoryResolver: ComponentFactoryResolver) { }

  public load(component: Type<any>, container: ViewContainerRef | void, inputs?: any, outputs?: any) {
    if (!component) { throw new Error('Component is undefined!'); }
    if (!container) { throw new Error('Container is undefined!'); }
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(component);
    this.destroy();
    this.componentRef = container.createComponent(componentFactory);
    if (inputs) {
      _.assign(this.componentRef.instance, inputs);
    }
    if (outputs) {
      _.assign(this.componentRef.instance, outputs);
    }
    return this.componentRef;
  }

  public destroy(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }
}
